import NoData from "../../../../components/noData/noData.component";
import Image from "../../../../components/Image/Image.component";

import { useTranslation } from "react-i18next";
import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { CiLocationOn, CiViewTable } from "react-icons/ci";
import { FiEye } from "react-icons/fi";
import { IoImagesOutline } from "react-icons/io5";
import { useReportForm } from "../context/reportFormContext";
import i18next from "i18next";

interface Props {
  reportsOrVoiceReports: string;
  reportsAnswers: any[];
  report: any;
  sites: any[];
  isLoading: string;
  searchValue: string;
  handleSelectFormIds: (id: string, reset?: boolean) => void;
  reportsFormIds: string[];
  handleSelectQuestionIds: (id: string, reset?: boolean) => void;
  selectedFormIds: string[];
  selectedQuestionIds: number[];
  filterValues: any;
  // servicesOptions: any[];
  // selectedService: string;
  sitevalue: number;
  setPreviewImage: (image: string) => void;
  setReportAnswerImages: (images: string[]) => void;
  versionId: any;
  reportVersion: any;
  nestedTable: any;
  setNestedTable: (id: string) => void;
  getDuration: (date: string, time: string) => string;
}

export default function ReportTable({
  reportsOrVoiceReports,
  reportsAnswers,
  report,
  sites,
  isLoading,
  handleSelectFormIds,
  selectedFormIds,
  reportsFormIds,
  handleSelectQuestionIds,
  selectedQuestionIds,
  filterValues,
  // servicesOptions,
  // selectedService,
  sitevalue,
  setPreviewImage,
  setReportAnswerImages,
  versionId,
  reportVersion,
  nestedTable,
  setNestedTable,
  getDuration,
}: Props) {
  const { t, i18n } = useTranslation();
  const tableContainerRef = useRef<HTMLDivElement>(null);
  const { isTakingSnapshot } = useReportForm();

  return (
    (reportsOrVoiceReports === "static" ||
      reportsOrVoiceReports === "dynamic") &&
    isLoading !== "report" && (
      <>
        {/* {report?.report_type !== "follow_up" &&
          report?.report_type !== "two_ways" && ( */}
        <div>
          {report?.report_title && reportsAnswers?.length === 0 ? (
            <div className="flex justify-center items-center h-96 mt-32">
              <NoData message={t("no_answers")} />
            </div>
          ) : (
            <div
              // onMouseOver={(e) => {
              //   const scrollableDiv = tableContainerRef?.current; // Get position and size of the div

              //   // Define the scrolling speed
              //   const scrollSpeed = 100;

              //   // Scroll to the right if the mouse is on the right side of the div
              //   if (e.clientX > 1700 && scrollableDiv) {
              //     scrollableDiv.scrollLeft += scrollSpeed;
              //   } else if (e.clientX < 350 && scrollableDiv) {
              //     scrollableDiv.scrollLeft -= scrollSpeed;
              //   }
              // }}
              ref={tableContainerRef}
              className="w-full overflow-x-auto mt-10 mb-20"
            >
              <table
                className={`border-solid w-full mb-4 ${
                  !report?.report_title && "hidden"
                }`}
                id="answers-table"
              >
                <thead>
                  <tr className="border-collapse border-2">
                    <th className="py-2 px-4 min-w-[1rem] border-collapse border-2"></th>
                    <th className="py-2 px-4 min-w-[10rem] border-collapse border-2">
                      {report?.report_type === "follow_up" ||
                      report?.report_type === "two_ways"
                        ? t("time_in")
                        : t("time")}
                    </th>
                    {(report?.report_type === "follow_up" ||
                      report?.report_type === "two_ways") && (
                      <th className="py-2 px-4 min-w-[10rem] border-collapse border-2">
                        {t("time_out")}
                      </th>
                    )}
                    {(report?.report_type === "follow_up" ||
                      report?.report_type === "two_ways") && (
                      <th className="py-2 px-4 min-w-[10rem] border-collapse border-2">
                        {t("duration")}
                      </th>
                    )}
                    {report?.report_category === "dynamic" &&
                      report?.report_type !== "follow_up" &&
                      report?.report_type !== "two_ways" && (
                        <th className="py-2 px-4 min-w-[10rem] border-collapse border-2">
                          {t("point_name")}
                        </th>
                      )}
                    {report?.report_category === "dynamic" &&
                      report?.report_type !== "follow_up" &&
                      report?.report_type !== "two_ways" && (
                        // selectedService && (
                        <th className="py-2 px-4 min-w-[10rem] border-collapse border-2">
                          {t("point_title")}
                        </th>
                      )}
                    {report?.report_category === "dynamic" &&
                      report?.report_type !== "follow_up" &&
                      report?.report_type !== "two_ways" && (
                        <th className="py-2 px-4 min-w-[10rem] border-collapse border-2">
                          {t("point_serial")}
                        </th>
                      )}
                    {report?.report_category === "dynamic" &&
                      report?.report_type !== "follow_up" &&
                      report?.report_type !== "two_ways" && (
                        <th className="py-2 px-4 min-w-[10rem] border-collapse border-2">
                          {t("site")}
                        </th>
                      )}
                    {report?.report_category === "dynamic" &&
                      report?.report_type !== "follow_up" &&
                      report?.report_type !== "two_ways" && (
                        <th className="py-2 px-4 min-w-[10rem] border-collapse border-2">
                          {t("risk_ratio")}
                        </th>
                      )}
                    <th className="py-2 px-4 min-w-[10rem] border-collapse border-2">
                      {report?.report_type === "follow_up" ||
                      report?.report_type === "two_ways"
                        ? t("client_users")
                        : t("user")}
                    </th>
                    <th className="py-2 px-4 min-w-[10rem] border-collapse border-2">
                      {t("location")}
                    </th>
                    {(report?.report_type === "follow_up" ||
                      report?.report_type === "two_ways") && (
                      <th className="py-2 px-4 min-w-[10rem] border-collapse border-2">
                        {t("view_table")}
                      </th>
                    )}
                    <th className="py-2 px-4 min-w-[10rem] border-collapse border-2">
                      {t("view_form")}
                    </th>
                    {report?.report_questions?.map(
                      (question: any, i: number) => {
                        if (
                          filterValues.stages?.length === 0 ||
                          filterValues.stages.includes(question.reportStage)
                        ) {
                          return (
                            <th
                              key={i}
                              className={`relative py-2 px-4 min-w-[10rem] border-collapse border-2 max-w-[30rem] truncate ${
                                selectedQuestionIds.includes(
                                  question.report_question_id
                                ) &&
                                "after:absolute after:inset-0 after:border-2 after:border-blue-500"
                              } ${question.level === 2 && "bg-secondary_1"} ${
                                question.level === 3 && "bg-secondary_2"
                              } ${question.level > 3 && "bg-secondary"}`}
                              onClick={() =>
                                handleSelectQuestionIds(
                                  question.report_question_id
                                )
                              }
                            >
                              {question.title}
                            </th>
                          );
                        }
                      }
                    )}
                  </tr>
                </thead>
                <tbody>
                  <tr className="h-6">
                    <td className=""></td>
                    <td className=""></td>
                    <td className=""></td>
                    <td className=""></td>
                    <td className=""></td>
                    <td className=""></td>
                  </tr>
                  {// report?.report_type !== "follow_up" &&
                  //   report?.report_type !== "two_ways" &&
                  reportsAnswers?.map((answerForm: any, index: number) => {
                    const FormId = reportsFormIds[index];
                    const stages =
                      report?.report_type === "follow_up"
                        ? ["opened", "actions", "closed"]
                        : ["opened", "closed"];
                    const users: any = [];
                    if (
                      report?.report_type === "follow_up" ||
                      report?.report_type === "two_ways"
                    ) {
                      stages.forEach((stage: any) => {
                        answerForm[stage].forEach((form: any) => {
                          const user = {
                            user_name: form.user_name,
                            user_pic: form.user_pic,
                            deleted: form.is_deleted_user,
                          };
                          if (
                            !users.some(
                              (u: any) => u.user_name === user.user_name
                            )
                          ) {
                            users.push(user);
                          }
                        });
                      });
                    } else {
                      users.push({
                        user_name: answerForm.user_name,
                        user_pic: answerForm.user_pic,
                        deleted: answerForm.is_deleted_user,
                      });
                    }

                    // console.log(users, "users");

                    return (
                      <tr
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSelectFormIds(FormId);
                        }}
                        key={index}
                        className={`relative border-collapse border-2 hover:bg-gray-100 duration-200 ${
                          selectedFormIds.includes(FormId) &&
                          "after:absolute after:inset-0 after:border-4 after:border-blue-500"
                        }`}
                      >
                        <td className="py-2 px-4 border-collapse border-2">
                          <span className="mx-auto flex justify-center">
                            {index + 1}
                          </span>
                        </td>

                        <td className="py-2 px-4 border-collapse border-2">
                          <span className="mx-auto flex justify-center">
                            {report?.report_type === "follow_up" ||
                            report?.report_type === "two_ways"
                              ? `${answerForm.opened[0]?.date} ${answerForm.opened[0]?.time}`
                              : `${answerForm.date} ${answerForm.time}`}
                          </span>
                        </td>

                        {(report?.report_type === "follow_up" ||
                          report?.report_type === "two_ways") && (
                          <td className="py-2 px-4 border-collapse border-2">
                            <span className="mx-auto flex justify-center">
                              {answerForm.closed.length > 0
                                ? `${answerForm.closed[0]?.date} ${answerForm.closed[0]?.time}`
                                : "N/A"}
                            </span>
                          </td>
                        )}
                        {(report?.report_type === "follow_up" ||
                          report?.report_type === "two_ways") && (
                          <td className="py-2 px-4 border-collapse border-2">
                            <span className="mx-auto flex justify-center">
                              {answerForm.closed.length > 0
                                ? getDuration(
                                    `${answerForm.opened[0]?.date} ${answerForm.opened[0]?.time}`,
                                    `${answerForm.closed[0]?.date} ${answerForm.closed[0]?.time}`
                                  )
                                : "N/A"}
                            </span>
                          </td>
                        )}

                        {report?.report_category === "dynamic" &&
                          report?.report_type !== "follow_up" &&
                          report?.report_type !== "two_ways" && (
                            <td className="py-2 px-4 border-collapse border-2">
                              <span className="mx-auto flex justify-center">
                                {answerForm?.point_name}
                              </span>
                            </td>
                          )}
                        {report?.report_category === "dynamic" &&
                          report?.report_type !== "follow_up" &&
                          report?.report_type !== "two_ways" && (
                            // selectedService && (
                            <td className="py-2 px-4 border-collapse border-2">
                              <span className="mx-auto flex justify-center">
                                {answerForm?.point_title || "__"}
                              </span>
                            </td>
                          )}
                        {report?.report_category === "dynamic" &&
                          report?.report_type !== "follow_up" &&
                          report?.report_type !== "two_ways" && (
                            <td className="py-2 px-4 border-collapse border-2">
                              <span className="mx-auto flex justify-center">
                                {answerForm?.point_serial || "__"}
                              </span>
                            </td>
                          )}
                        {report?.report_category === "dynamic" &&
                          report?.report_type !== "follow_up" &&
                          report?.report_type !== "two_ways" && (
                            <td className="py-2 px-4 border-collapse border-2">
                              <span className="mx-auto flex justify-center">
                                {
                                  sites.find(
                                    (site: any) => site.site_id === sitevalue
                                  )?.site_name
                                }
                              </span>
                            </td>
                          )}
                        {report?.report_category === "dynamic" &&
                          report?.report_type !== "follow_up" &&
                          report?.report_type !== "two_ways" && (
                            <td className="py-2 px-4 border-collapse border-2">
                              <span
                                style={{
                                  color:
                                    answerForm.risk_ratio == "low"
                                      ? "green"
                                      : answerForm.risk_ratio == "moderate"
                                        ? "orange"
                                        : "red",
                                }}
                                className="mx-auto flex justify-center capitalize"
                              >
                                {answerForm.risk_ratio}
                              </span>
                            </td>
                          )}
                        <td className="py-2 px-4 border-collapse border-2">
                          <div className="flex justify-center items-center">
                            {users.map((user: any, index: number) => {
                              if (index > 1) return null;
                              return (
                                // TODO: handle if there more then 2 users
                                <div
                                  key={index}
                                  data-tooltip={user.user_name}
                                  className={`w-16 h-16 rounded-full object-contain custom-tooltip hover:before:content-[attr(data-tooltip)]
                          ${i18next.language === "ar" ? "-ml-3" : "-mr-3"} ${
                            user?.deleted && "relative"
                          }`}
                                  onClick={() =>
                                    setPreviewImage(
                                      answerForm[0]?.user?.profile_pic
                                    )
                                  }
                                >
                                  <Image
                                    className={`max-w-[90%] h-[90%] object-cover rounded-full cursor-pointer`}
                                    src={user.user_pic}
                                    alt={user.user_name}
                                  />
                                  {user?.deleted && (
                                    <span className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-40 flex justify-center items-center text-white text-xs font-bold rounded-full">
                                      {t("deleted")}
                                    </span>
                                  )}
                                </div>
                              );
                            })}
                            {users.length > 2 && (
                              <span
                                data-tooltip={t("more")}
                                className="text-2xl font-bold max-w-[90%] h-[90%] rounded-full bg-secondary text-text cursor-pointer flex justify-center items-center custom-tooltip hover:before:content-[attr(data-tooltip)]"
                              >
                                +{users.length - 2}
                              </span>
                            )}
                          </div>
                        </td>
                        <td
                          onClick={(e) => e.stopPropagation()}
                          className="py-2 px-4 border-collapse border-2"
                        >
                          <a
                            className="mx-auto flex justify-center text-blue-500"
                            href={
                              report?.report_type === "follow_up" ||
                              report?.report_type === "two_ways"
                                ? answerForm.opened[0].GPS
                                : answerForm.GPS
                            }
                            target="_blank"
                          >
                            <CiLocationOn className="text-4xl text-text hover:text-secondary_text duration-300" />
                          </a>
                        </td>

                        {(report?.report_type === "follow_up" ||
                          report?.report_type === "two_ways") && (
                          <td
                            className="py-2 px-4 border-collapse border-2 cursor-pointer text-blue-500"
                            onClick={(e) => {
                              e.stopPropagation();
                              setNestedTable(answerForm?.flow_id);
                              handleSelectFormIds("", true);
                              handleSelectQuestionIds("", true);
                            }}
                          >
                            <div className="flex justify-center items-center">
                              <CiViewTable className="text-3xl text-text cursor-pointer opacity-60 hover:opacity-100 duration-200" />
                            </div>
                          </td>
                        )}
                        <td
                          className="py-2 px-4 border-collapse border-2 cursor-pointer text-blue-500"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <Link
                            to={`form/${nestedTable ? nestedTable : FormId}?report_id=${report.report_id}&version=${reportVersion}&versionId=${versionId}&site_id=${sitevalue}${report?.report_type === "follow_up" || report?.report_type === "two_ways" ? `&stages=true` : ""}${nestedTable ? `&stages=true&form_id=${FormId}` : ""}`}
                            className="flex justify-center items-center"
                          >
                            {/* ${
                              selectedService
                                ? `&service_name=${
                                    servicesOptions?.find(
                                      (service: any) =>
                                        service?.value == selectedService
                                    )?.label
                                  }`
                                : ""
                            } */}
                            <FiEye className="text-3xl text-text cursor-pointer opacity-60 hover:opacity-100 duration-200" />
                          </Link>
                        </td>
                        {report?.report_questions?.map(
                          (question: any, index: number) => {
                            if (
                              filterValues.stages?.length === 0 ||
                              filterValues.stages.includes(question.reportStage)
                            ) {
                              const stage =
                                question.reportStage === "Opened"
                                  ? "opened"
                                  : question.reportStage === "Action"
                                    ? "actions"
                                    : "closed";
                              const stageIndex =
                                stage === "actions"
                                  ? answerForm?.[stage]?.length - 1
                                  : 0;
                              const form: any =
                                report?.report_type !== "follow_up" &&
                                report?.report_type !== "two_ways"
                                  ? answerForm
                                  : answerForm?.[stage].length > 0 &&
                                      answerForm?.[stage]?.[stageIndex]
                                    ? answerForm?.[stage]?.[stageIndex]
                                    : {};

                              // if (stage === "actions") {
                              //   console.log(form, stage, stageIndex, "form");
                              // }

                              return (
                                <td
                                  key={`${index + 1} - ${question.report_question_id} ${question.title}`}
                                  className={`py-2 px-4 border-collapse border-2 ${
                                    question.level === 2 && "bg-secondary_1"
                                  } ${
                                    question.level === 3 && "bg-secondary_2"
                                  } ${question.level > 3 && "bg-secondary"}`}
                                  style={
                                    isTakingSnapshot ? { height: "200px" } : {}
                                  }
                                >
                                  {!form?.answers ||
                                  form?.answers?.filter(
                                    (answer: any) =>
                                      answer.report_question_id ===
                                      question.report_question_id
                                  )?.length === 0 ? (
                                    <p className="flex justify-evenly text-gray-500 min-w-[6rem] px-2">
                                      {t("no_answers")}
                                    </p>
                                  ) : (
                                    form?.answers?.map((answer: any) => {
                                      if (
                                        answer.report_question_id ===
                                        question.report_question_id
                                      ) {
                                        return (
                                          <div className="flex items-center gap-4">
                                            <p
                                              dir={
                                                i18n.language == "ar"
                                                  ? "rtl"
                                                  : "ltr"
                                              }
                                              className="truncate p-4"
                                            >
                                              {answer.answer_choices.map(
                                                (
                                                  choice: any,
                                                  choiceIndex: number
                                                ) =>
                                                  choiceIndex > 0
                                                    ? `, ${choice.text}`
                                                    : question?.type === "Date"
                                                    ? new Date(choice.text)
                                                    .toString()
                                                    .split("GMT")[0]
                                                    : question?.type === "AI" && question?.aiType === "NationalID"
                                                    ? JSON.parse(choice.text).national_id + " ..."
                                                    : choice.text
                                              )}
                                            </p>
                                            {question?.attachImage && (
                                              <div
                                                className="flex items-center max-h-16 min-w-[4rem]"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  setReportAnswerImages(
                                                    answer.question_pic
                                                  );
                                                }}
                                              >
                                                {isTakingSnapshot
                                                  ? answer.question_pic && (
                                                      <div className="flex gap-2 items-center">
                                                        {answer.question_pic.map(
                                                          (pic: {
                                                            question_picture_url: string;
                                                          }) => {
                                                            if (
                                                              pic.question_picture_url.endsWith(
                                                                ".jpg"
                                                              ) ||
                                                              pic.question_picture_url.endsWith(
                                                                ".png"
                                                              ) ||
                                                              pic.question_picture_url.endsWith(
                                                                ".jpeg"
                                                              )
                                                            ) {
                                                              return (
                                                                <Image
                                                                  className="w-[175px] h-[195px] object-contain"
                                                                  src={
                                                                    pic.question_picture_url
                                                                  }
                                                                  alt="Question Image"
                                                                />
                                                              );
                                                            }
                                                          }
                                                        )}
                                                      </div>
                                                    )
                                                  : null}

                                                {!isTakingSnapshot && (
                                                  <IoImagesOutline className="text-xl text-text cursor-pointer opacity-60 hover:opacity-100 duration-200" />
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        );
                                      } else {
                                        return null;
                                      }
                                    })
                                  )}
                                </td>
                              );
                            }
                          }
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </>
    )
  );
}
